theme.headerSection = (function () {
  let isHeaderInitialized = false;
  function header() {
    if (isHeaderInitialized) return;
    isHeaderInitialized = true;
    /* Mobile Navigation Drawer Functionality */
    const MobileMenu = function () {
      const offcanvasOpenTriggers = document.querySelectorAll(
          ".header__actions_btn--menu, .js-mobile-drawer-trigger, [data-drawer-trigger]"
        ),
        offcanvasCloseButtons = document.querySelectorAll(
          ".offcanvas__close_btn, .ssps-drawer__close-btn"
        ),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasOverlay = document.querySelector(".offcanvas-overlay"),
        offcanvasMenuAll = document.querySelectorAll(".offcanvas__menu"),
        body = document.body || document.querySelector("body");

      if (!offcanvasHeader) return;

      /* Reparent drawer and overlay directly to body to guarantee full viewport height (100dvh) */
      if (offcanvasHeader.parentElement !== document.body) {
        document.body.appendChild(offcanvasHeader);
      }
      if (offcanvasOverlay && offcanvasOverlay.parentElement !== document.body) {
        document.body.appendChild(offcanvasOverlay);
      }

      /* Helper: Open Drawer */
      const openDrawer = function (targetTab) {
        offcanvasHeader.classList.add("open");
        if (offcanvasOverlay) {
          offcanvasOverlay.classList.add("active");
        }
        body.style.overflowY = "hidden";
        body.classList.add("mobile-drawer-open");

        if (targetTab) {
          switchDrawerTab(targetTab);
        }

        if (!window.history.state?.mobileNavOpen) {
          window.history.pushState({ mobileNavOpen: true }, "", window.location.href);
        }
      };

      /* Helper: Close Drawer */
      const closeDrawer = function (fromPopstate) {
        offcanvasHeader.classList.remove("open");
        if (offcanvasOverlay) {
          offcanvasOverlay.classList.remove("active");
        }
        body.style.overflowY = null;
        body.classList.remove("mobile-drawer-open");

        if (!fromPopstate && window.history.state?.mobileNavOpen) {
          window.history.back();
        }
      };

      /* Helper: Switch Tab */
      const switchDrawerTab = function (tabName) {
        document.querySelectorAll(".js-drawer-tab").forEach(function (btn) {
          const isTarget = btn.getAttribute("data-tab") === tabName;
          btn.classList.toggle("active", isTarget);
          btn.setAttribute("aria-selected", isTarget ? "true" : "false");
        });
        document.querySelectorAll(".ssps-drawer__tab-panel").forEach(function (panel) {
          const isTarget = panel.id === "drawer-panel-" + tabName;
          panel.classList.toggle("active", isTarget);
        });
      };

      /* Open Drawer on Any Trigger Click */
      offcanvasOpenTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function (e) {
          const drawerTarget = this.getAttribute("data-drawer-trigger");
          if (drawerTarget || this.classList.contains("header__actions_btn--menu") || this.classList.contains("js-mobile-drawer-trigger")) {
            e.preventDefault();
            openDrawer(drawerTarget || "categories");
          }
        });
      });

      /* Close Drawer on Close Button Click */
      offcanvasCloseButtons.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          closeDrawer();
        });
      });

      /* Close Drawer on Backdrop Click */
      if (offcanvasOverlay) {
        offcanvasOverlay.addEventListener("click", function (e) {
          e.preventDefault();
          closeDrawer();
        });
      }

      /* Segmented Controller Tab Clicks */
      document.querySelectorAll(".js-drawer-tab").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          const tabName = this.getAttribute("data-tab");
          if (tabName) {
            switchDrawerTab(tabName);
          }
        });
      });

      /* Submenu Accordion Toggles */
      if (offcanvasMenuAll.length > 0) {
        offcanvasMenuAll.forEach(function (offcanvasMenu) {
          /* Toggle click handler */
          offcanvasMenu
            .querySelectorAll(".offcanvas__sub_menu_toggle")
            .forEach(function (toggle) {
              toggle.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                const parent = this.closest(".offcanvas__menu_li, .offcanvas__sub_menu_li") || this.parentElement;
                const subMenu = parent.querySelector(":scope > .offcanvas__sub_menu");

                if (parent.classList.contains("active")) {
                  this.classList.remove("active");
                  parent.classList.remove("active");
                  if (subMenu && typeof slideUp === "function") {
                    slideUp(subMenu);
                  } else if (subMenu) {
                    subMenu.style.display = "none";
                  }
                } else {
                  this.classList.add("active");
                  parent.classList.add("active");
                  if (subMenu && typeof slideDown === "function") {
                    slideDown(subMenu);
                  } else if (subMenu) {
                    subMenu.style.display = "block";
                  }

                  /* Close siblings */
                  if (typeof getSiblings === "function") {
                    getSiblings(parent).forEach(function (item) {
                      item.classList.remove("active");
                      const siblingToggle = item.querySelector(":scope > .offcanvas__sub_menu_toggle, :scope > .ssps-drawer__row > .offcanvas__sub_menu_toggle, :scope > .ssps-drawer__subrow > .offcanvas__sub_menu_toggle");
                      if (siblingToggle) siblingToggle.classList.remove("active");
                      const siblingSubMenu = item.querySelector(":scope > .offcanvas__sub_menu");
                      if (siblingSubMenu && typeof slideUp === "function") {
                        slideUp(siblingSubMenu);
                      } else if (siblingSubMenu) {
                        siblingSubMenu.style.display = "none";
                      }
                    });
                  }
                }
              });
            });

          /* Handle parent category link clicks to expand submenu and leaf links to close drawer */
          offcanvasMenu
            .querySelectorAll(".offcanvas__menu_li, .offcanvas__sub_menu_li")
            .forEach(function (item) {
              const toggle = item.querySelector(".offcanvas__sub_menu_toggle");
              const link = item.querySelector(":scope > a, :scope > .ssps-drawer__row > a, :scope > .ssps-drawer__subrow > a");

              if (toggle && link) {
                link.addEventListener("click", function (e) {
                  e.preventDefault();
                  toggle.click();
                });
              } else if (link && !toggle) {
                link.addEventListener("click", function () {
                  closeDrawer();
                });
              }
            });
        });

        /* Close drawer when tapping any navigation row or footer link */
        offcanvasHeader.querySelectorAll(".ssps-drawer__row, .ssps-drawer__sublink, .ssps-drawer__footer a").forEach(function (leafLink) {
          leafLink.addEventListener("click", function () {
            const href = (this.getAttribute("href") || "").trim();
            if (href && href !== "#" && !href.startsWith("javascript:")) {
              closeDrawer();
            }
          });
        });
      }

      /* Close on Outside Document Click */
      document.addEventListener("click", function (event) {
        if (!offcanvasHeader.classList.contains("open")) return;
        const target = event.target;
        if (
          !target.closest(".offcanvas-header") &&
          !target.closest(".header__actions_btn--menu") &&
          !target.closest(".js-mobile-drawer-trigger") &&
          !target.closest("[data-drawer-trigger]")
        ) {
          closeDrawer();
        }
      });

      /* Close on Escape Key */
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && offcanvasHeader.classList.contains("open")) {
          closeDrawer();
        }
      });

      /* Touch Swipe to Dismiss (Left Swipe) */
      let touchStartX = 0;
      let touchStartY = 0;
      offcanvasHeader.addEventListener(
        "touchstart",
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
          touchStartY = e.changedTouches[0].screenY;
        },
        { passive: true }
      );

      offcanvasHeader.addEventListener(
        "touchend",
        function (e) {
          const touchEndX = e.changedTouches[0].screenX;
          const touchEndY = e.changedTouches[0].screenY;
          const diffX = touchStartX - touchEndX;
          const diffY = Math.abs(touchStartY - touchEndY);
          if (diffX > 50 && diffY < 100) {
            closeDrawer();
          }
        },
        { passive: true }
      );

      /* Auto-close when resizing to desktop (>= 992px) */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992 && offcanvasHeader.classList.contains("open")) {
          closeDrawer();
        }
      });

      /* Handle Android WebView / Browser Back */
      window.addEventListener("popstate", function () {
        if (offcanvasHeader.classList.contains("open")) {
          closeDrawer(true);
        }
      });

      /* Restore clean body state on bfcache page restore */
      window.addEventListener("pageshow", function () {
        if (offcanvasHeader.classList.contains("open")) {
          closeDrawer(true);
        }
      });
    };

    /* Initialize Mobile Menu */
    MobileMenu();

    /* Legacy toggle buttons if present on page */
    const mobileMenuToggleButtons = document.querySelectorAll(".mobile--menu-header-button");
    const mobileMainMenu = document.querySelector(".mobile__main-menu--list");
    const mobileVerticalMenu = document.querySelector(".mobile__categories--list");
    if (mobileMenuToggleButtons.length > 0) {
      mobileMenuToggleButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          mobileMenuToggleButtons.forEach(function (childButton) {
            childButton.classList.remove("active");
          });
          if (button.classList.contains("mobile__main--menu")) {
            button.classList.add("active");
            if (mobileMainMenu) mobileMainMenu.classList.remove("d-none");
            if (mobileVerticalMenu) mobileVerticalMenu.classList.add("d-none");
          }
          if (button.classList.contains("mobile__categories--menu")) {
            button.classList.add("active");
            if (mobileVerticalMenu) mobileVerticalMenu.classList.remove("d-none");
            if (mobileMainMenu) mobileMainMenu.classList.add("d-none");
          }
        });
      });
    }
  }

  /* Self-initialize on DOM ready */
  document.addEventListener("DOMContentLoaded", function () {
    header();
  });
  if (document.readyState === "interactive" || document.readyState === "complete") {
    setTimeout(header, 10);
  }

  return header;
})();
